import React, { useState } from 'react';
import { Row, Col, Card, CardBody, Button } from 'reactstrap';
import Option from './Option';
import IntlMessages from '../../../../../helpers/IntlMessages';
export default function Bedroom({ oneBedroom, roomData, setRoomData, handleRemoveBedRooms, roomindex }) {
  const [isExtensional, setIsExtensional] = useState(false);
  const initOption = {
    bedding_option: [
      {
        bedding: [
          {
            bed_type: '',
            no_of_beds: '',
          }
        ],
      }
    ],
  };
  return (
    <Row className="mb-4">
      <Col xxs="12">
        <Card>
          <CardBody>
            <h3>
              <IntlMessages id='dashboards.bedroom' /> {roomindex + 1}
              {isExtensional ? (
                <Button
                  color="primary"
                  outline
                  size="xs"
                  className="float-right"
                  onClick={() => setIsExtensional(!isExtensional)}
                >
                  Collapse <span style={{ fontSize: '8px' }}>▲</span>
                </Button>
              ) : (
                <Button
                  color="primary"
                  outline
                  size="xs"
                  className="float-right"
                  onClick={() => setIsExtensional(!isExtensional)}
                >
                  <IntlMessages id='menu.details' /> <span style={{ fontSize: '8px' }}>▼</span>
                </Button>
              )}
              <Button
                onClick={() => handleRemoveBedRooms(roomindex)}
                color="secondary"
                size="xs"
                outline
                style={{ margin: '6px' }}
              >
                -
              </Button>
            </h3>
            <hr />
            <Row>
              {oneBedroom ? (
                // oneBedroom.bedding_option.map((option, index) => {
                // return (
                <Row style={{ padding: '0px 18px' }}>
                  <Col xxs={12}>
                    <Option option={oneBedroom} isExtensional={isExtensional} roomData={roomData} setRoomData={setRoomData} roomindex={roomindex} />
                  </Col>
                </Row>
                //);
                //})
              ) : (
                <Row style={{ padding: '0px 18px' }}>
                  <Col xxs={12}>
                    <Option option={initOption} isExtensional={true} roomData={roomData} setRoomData={setRoomData} roomindex={roomindex} />
                  </Col>
                  {/* <Col xxs={6}>
                      <Option option={initOption} isExtensional={true} />
                    </Col> */}
                </Row>
              )}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
